import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.reviewops.industry.classification');
import { Input } from '@angular/core';

interface IndustryCandidate {
    industry: string;
    confidence: number;
}

interface IndustryClassificationData {
    primary_industry?: string;
    secondary_industry?: string | null;
    sub_industry?: string;
    confidence_score?: number;
    classification_reason?: string;
    keywords?: string[];
    candidates?: IndustryCandidate[];
    is_uncertain?: boolean;
}

@Component({
    selector: 'wiz-component-reviewops-industry-classification',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.reviewops.industry.classification/view.scss */
/* src/app/component.reviewops.industry.classification/view.scss: no such file or directory */`],
})
export class ComponentReviewopsIndustryClassificationComponent {
    @Input() classification: IndustryClassificationData = {};
}

export default ComponentReviewopsIndustryClassificationComponent;